/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stats_Releases_Yearlytitle1Inputs */

const id_stats_releases_yearlytitle1 = /** @type {(inputs: Stats_Releases_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rilis tahunan`)
};

const ms_stats_releases_yearlytitle1 = /** @type {(inputs: Stats_Releases_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keluaran tahunan`)
};

const da_stats_releases_yearlytitle1 = /** @type {(inputs: Stats_Releases_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Årlige udgivelser`)
};

const de_stats_releases_yearlytitle1 = /** @type {(inputs: Stats_Releases_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jährliche Veröffentlichungen`)
};

const en_us2_stats_releases_yearlytitle1 = /** @type {(inputs: Stats_Releases_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yearly releases`)
};

const es_es2_stats_releases_yearlytitle1 = /** @type {(inputs: Stats_Releases_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lanzamientos anuales`)
};

const es_mx2_stats_releases_yearlytitle1 = /** @type {(inputs: Stats_Releases_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lanzamientos anuales`)
};

const fil_stats_releases_yearlytitle1 = /** @type {(inputs: Stats_Releases_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taunang release`)
};

const fr_stats_releases_yearlytitle1 = /** @type {(inputs: Stats_Releases_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorties annuelles`)
};

const it_stats_releases_yearlytitle1 = /** @type {(inputs: Stats_Releases_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uscite annuali`)
};

const hu_stats_releases_yearlytitle1 = /** @type {(inputs: Stats_Releases_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Éves megjelenések`)
};

const nl_stats_releases_yearlytitle1 = /** @type {(inputs: Stats_Releases_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jaarlijkse releases`)
};

const no_stats_releases_yearlytitle1 = /** @type {(inputs: Stats_Releases_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Årlige utgivelser`)
};

const pl_stats_releases_yearlytitle1 = /** @type {(inputs: Stats_Releases_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wydania roczne`)
};

const pt_br2_stats_releases_yearlytitle1 = /** @type {(inputs: Stats_Releases_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lançamentos anuais`)
};

const pt_stats_releases_yearlytitle1 = /** @type {(inputs: Stats_Releases_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lançamentos anuais`)
};

const ro_stats_releases_yearlytitle1 = /** @type {(inputs: Stats_Releases_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lansări anuale`)
};

const fi_stats_releases_yearlytitle1 = /** @type {(inputs: Stats_Releases_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vuosittaiset julkaisut`)
};

const sv_stats_releases_yearlytitle1 = /** @type {(inputs: Stats_Releases_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Årliga släpp`)
};

const vi_stats_releases_yearlytitle1 = /** @type {(inputs: Stats_Releases_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phát hành hàng năm`)
};

const tr_stats_releases_yearlytitle1 = /** @type {(inputs: Stats_Releases_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yıllık çıkışlar`)
};

const cs_stats_releases_yearlytitle1 = /** @type {(inputs: Stats_Releases_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roční vydání`)
};

const bg_stats_releases_yearlytitle1 = /** @type {(inputs: Stats_Releases_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Годишни издавания`)
};

const ru_stats_releases_yearlytitle1 = /** @type {(inputs: Stats_Releases_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ежегодные релизы`)
};

const uk_stats_releases_yearlytitle1 = /** @type {(inputs: Stats_Releases_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Щорічні релізи`)
};

const ar_stats_releases_yearlytitle1 = /** @type {(inputs: Stats_Releases_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الإصدارات السنوية`)
};

const hi_stats_releases_yearlytitle1 = /** @type {(inputs: Stats_Releases_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वार्षिक रिलीज़`)
};

const th_stats_releases_yearlytitle1 = /** @type {(inputs: Stats_Releases_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การวางจำหน่ายรายปี`)
};

const ja_stats_releases_yearlytitle1 = /** @type {(inputs: Stats_Releases_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年別リリース数`)
};

const zh_cn2_stats_releases_yearlytitle1 = /** @type {(inputs: Stats_Releases_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每年发布`)
};

const zh_hant1_stats_releases_yearlytitle1 = /** @type {(inputs: Stats_Releases_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每年發布`)
};

const ko_stats_releases_yearlytitle1 = /** @type {(inputs: Stats_Releases_Yearlytitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`연별 출시`)
};

/**
* | output |
* | --- |
* | "Yearly releases" |
*
* @param {Stats_Releases_Yearlytitle1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const stats_releases_yearlytitle1 = /** @type {((inputs?: Stats_Releases_Yearlytitle1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stats_Releases_Yearlytitle1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_stats_releases_yearlytitle1(inputs)
	if (locale === "ms") return ms_stats_releases_yearlytitle1(inputs)
	if (locale === "da") return da_stats_releases_yearlytitle1(inputs)
	if (locale === "de") return de_stats_releases_yearlytitle1(inputs)
	if (locale === "en-US") return en_us2_stats_releases_yearlytitle1(inputs)
	if (locale === "es-ES") return es_es2_stats_releases_yearlytitle1(inputs)
	if (locale === "es-MX") return es_mx2_stats_releases_yearlytitle1(inputs)
	if (locale === "fil") return fil_stats_releases_yearlytitle1(inputs)
	if (locale === "fr") return fr_stats_releases_yearlytitle1(inputs)
	if (locale === "it") return it_stats_releases_yearlytitle1(inputs)
	if (locale === "hu") return hu_stats_releases_yearlytitle1(inputs)
	if (locale === "nl") return nl_stats_releases_yearlytitle1(inputs)
	if (locale === "no") return no_stats_releases_yearlytitle1(inputs)
	if (locale === "pl") return pl_stats_releases_yearlytitle1(inputs)
	if (locale === "pt-BR") return pt_br2_stats_releases_yearlytitle1(inputs)
	if (locale === "pt") return pt_stats_releases_yearlytitle1(inputs)
	if (locale === "ro") return ro_stats_releases_yearlytitle1(inputs)
	if (locale === "fi") return fi_stats_releases_yearlytitle1(inputs)
	if (locale === "sv") return sv_stats_releases_yearlytitle1(inputs)
	if (locale === "vi") return vi_stats_releases_yearlytitle1(inputs)
	if (locale === "tr") return tr_stats_releases_yearlytitle1(inputs)
	if (locale === "cs") return cs_stats_releases_yearlytitle1(inputs)
	if (locale === "bg") return bg_stats_releases_yearlytitle1(inputs)
	if (locale === "ru") return ru_stats_releases_yearlytitle1(inputs)
	if (locale === "uk") return uk_stats_releases_yearlytitle1(inputs)
	if (locale === "ar") return ar_stats_releases_yearlytitle1(inputs)
	if (locale === "hi") return hi_stats_releases_yearlytitle1(inputs)
	if (locale === "th") return th_stats_releases_yearlytitle1(inputs)
	if (locale === "ja") return ja_stats_releases_yearlytitle1(inputs)
	if (locale === "zh-CN") return zh_cn2_stats_releases_yearlytitle1(inputs)
	if (locale === "zh-Hant") return zh_hant1_stats_releases_yearlytitle1(inputs)
	return ko_stats_releases_yearlytitle1(inputs)
});
export { stats_releases_yearlytitle1 as "stats.releases.yearlyTitle" }